import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import MarketSignalScroller from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTowerCell } from '@fortawesome/free-solid-svg-icons';
import { Permissions } from '@/core/permissions/export';
import { MarketSignalContextProvider } from '@/modules/market-signals/contexts/market-signal-context';

export class MarketSignalScrollerWidget implements NewsWidget {
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return 'Market Signals';
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return !this.shouldHideToUser(permissions);
  }

  shouldHideToUser(permissions: string[]): boolean {
    return (
      !permissions.includes(Permissions.ALPHA_ACCESS) &&
      !permissions.includes(Permissions.ALPHA_ACCESS_MARKET_SIGNALS)
    );
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <span className={'text-warning'}>
        <FontAwesomeIcon icon={faTowerCell} /> Market Signals
      </span>
    );
  }

  get id(): string {
    return 'market-signals';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: (
          <MarketSignalContextProvider>
            <MarketSignalScroller />
          </MarketSignalContextProvider>
        ),
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return this.headerPanel;
  }
}
